import { baseClient, API } from "../index";
import { upload, uploadSingleFile } from "../files";

export const postGroup = async (group, image) => {
	if (image) {
		const res = await upload(image);
		group.image = res.fileURL;
	}
	return baseClient().post(`${API}/group`, group);
};

export const updateGroup = async (id, group, image) => {
	if (image) {
		const response = await uploadSingleFile(image, "groups");
		group.image = response.data.fileURL;
	}
	return baseClient().put(`${API}/group/${id}`, group);
};

export const getGroupById = async (id) => {
	return baseClient().get(`${API}/group/${id}`);
};

// Get group by table & game
export const getGroupByTableAndGame = async (table, game) => {
	return baseClient().get(`${API}/group/table/${table}/game/${game}`);
};

/** Propuesta de inversión esc. 5 (espera al resto / consenso / fallo). */
export const postS5InvestmentProposal = async (groupId, payload) => {
	return baseClient().post(
		`${API}/group/${groupId}/s5-investment-proposal`,
		payload
	);
};

export const deleteS5InvestmentProposal = async (groupId) => {
	return baseClient().delete(
		`${API}/group/${groupId}/s5-investment-proposal`
	);
};

/** Polling estado ronda (gameId + groupId opcional para myProposal). */
export const getS5InvestmentSync = async (gameId, groupId) => {
	return baseClient().get(`${API}/group/game/${gameId}/s5-investment-sync`, {
		params: groupId ? { groupId } : {},
	});
};
